import $ from 'jquery';
import baseInitialize from './base';
import AnalyticsEventTypes from 'components/analytics/AnalyticsEventTypes';
import ContactCategories from 'components/contactCategories/ContactCategories';
import EventTypes from 'components/EventTypes';

baseInitialize();

new ContactCategories({
  categorySelector: '.js-category-selector',
  subCategorySelector: '.js-subcategory-selector',
});

document.jq.one(EventTypes.DEFERRED_INITIALIZE_COMPLETE, () => {
  const form = document.querySelector('.js-contactForm');

  if (!form) {
    return;
  }

  form.jq.data('api').attachSubmitCallback(() => {
    const deferred = $.Deferred();
    const categorySelect = form.querySelector('.js-category-selector');

    if (!categorySelect) {
      return;
    }

    const eventCallback = () => {
      clearTimeout(timeoutId);
      deferred.resolve();
    };

    const selectedOption = categorySelect.options[categorySelect.selectedIndex];
    document.jq.trigger(AnalyticsEventTypes.CONTACT_FORM_SUBMIT, {
      eventCallback,
      label: selectedOption.dataset.labelEn.toLowerCase(),
    });
    const timeoutId = setTimeout(eventCallback, 750);

    return deferred;
  });
});

const emailUsBtn = document.querySelector('.js-open-email-us');

const scrollIntoViewWithOffset = (element, topOffset) => {
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition - topOffset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

if (emailUsBtn) {
  emailUsBtn.addEventListener('click', () => {
    const emailUsSection = document.querySelector('.contact-us__email-us');
    const emailFormHeading = document.querySelector('#contact-email-form-heading');

    if (emailUsSection && !emailUsSection.classList.contains('contact-us__email-us--visible')) {
      emailUsSection.classList.add('contact-us__email-us--visible');
      emailUsBtn.setAttribute('aria-expanded', 'true');
      scrollIntoViewWithOffset(emailUsSection, 70);
    }
    if (emailFormHeading) {
      emailFormHeading.focus();
    }
  });
}

const chatBtn = document.querySelector('.js-open-chat');

if (chatBtn) {
  chatBtn.addEventListener('click', () => {
    if (window?.dgchat?.methods?.launchWidget) {
      try {
        window.dgchat.methods.launchWidget();
      } catch (error) {
        console.error('Failed to launch chat widget:', error);
      }
    }
  });
}

const phoneBtn = document.querySelector('.js-show-phone');

if (phoneBtn) {
  phoneBtn.addEventListener('click', () => {
    const phoneNumber = document.querySelector('.js-phone-number');

    if (phoneNumber && !phoneNumber.classList.contains('contact-us__tile-phone--visible')) {
      phoneNumber.classList.add('contact-us__tile-phone--visible');
      phoneBtn.setAttribute('aria-expanded', 'true');
      const phoneLink = phoneNumber.querySelector('a');
      if (phoneLink) {
        phoneLink.focus();
      }
    }
  });
}

const phoneLink = document.querySelector('.js-phone-number a[href^="tel:"]');
if (phoneLink) {
  const ariaLabel = window.labels?.contactPage?.phoneAriaLabel;
  if (ariaLabel) {
    phoneLink.setAttribute('aria-label', `${phoneLink.textContent.trim()}, ${ariaLabel}`);
  }
}
